import validationRules from "../validationRules";
validationRules.register("email", function (record, fieldMetadataMap, fieldName, t) {
    var name = record["email1"] || "";
    var errorStr = [];
    if (Array.isArray(name)) {
        name.forEach(function (element) {
            var value = element.email_address || "";
            var er = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if ((typeof value === "string" && value.length === 0) ||
                er.test(value)) {
                errorStr.push(1);
            }
            else {
                errorStr.push(0);
            }
        });
        return errorStr.includes(0) ? "Invalid email format." : true;
    }
    return true;
});
